var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dealings-balance-view2-multi-currency" }, [
    _c(
      "div",
      {
        staticClass: "section operations",
        staticStyle: { "margin-bottom": "2px" }
      },
      [
        _c(
          "el-form",
          { staticStyle: { "margin-bottom": "-12px" }, attrs: { inline: "" } },
          [
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_AccountTitle") } },
              [
                _c(
                  "el-select",
                  {
                    ref: "accountTitleRef",
                    staticStyle: { width: "300px" },
                    attrs: { filterable: true, clearable: true, no: "1" },
                    model: {
                      value: _vm.form.accountTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "accountTitle", $$v)
                      },
                      expression: "form.accountTitle"
                    }
                  },
                  _vm._l(_vm.currentAccountTitleCollection, function(
                    item,
                    index
                  ) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.accountTitleLabelFun(item),
                        value: item.uuid
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_Salesman") } },
              [
                _c("cargo-advance-select", {
                  staticStyle: { width: "140px" },
                  attrs: {
                    "callback-params": { key: "sales" },
                    "default-value": _vm.form.sales,
                    "select-type": _vm.selectTypeNames.basic_data_User,
                    "callback-method-type": "value",
                    filterable: "",
                    no: "2"
                  },
                  on: { parentCallBack: _vm.selectChangeHandler }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_Customer") } },
              [
                _c("cargo-advance-select", {
                  staticStyle: { width: "300px" },
                  attrs: {
                    "callback-params": { key: "customer" },
                    "default-value": _vm.form.customer,
                    "select-type": _vm.selectTypeNames.basic_data_Company,
                    "callback-method-type": "value",
                    filterable: "",
                    no: "3"
                  },
                  on: { parentCallBack: _vm.selectChangeHandler }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessDocNo") } },
              [
                _c("el-input", {
                  staticStyle: { width: "140px" },
                  attrs: { no: "4" },
                  model: {
                    value: _vm.form.projectNumber,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "projectNumber", $$v)
                    },
                    expression: "form.projectNumber"
                  }
                })
              ],
              1
            ),
            _c("br"),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_Department") } },
              [
                _c("cargo-advance-select", {
                  staticStyle: { width: "150px" },
                  attrs: {
                    "callback-params": { key: "departmentId" },
                    "default-value": _vm.form.departmentId,
                    "select-type": _vm.selectTypeNames.basic_data_Department,
                    "method-params": {
                      officeUuid: _vm.$store.getters.currentOfficeUuid
                    },
                    "callback-method-type": "value",
                    filterable: "",
                    no: "5"
                  },
                  on: { parentCallBack: _vm.selectChangeHandler }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_Currency") } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "105px" },
                    attrs: { no: "6" },
                    model: {
                      value: _vm.form.currency,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "currency", $$v)
                      },
                      expression: "form.currency"
                    }
                  },
                  _vm._l(_vm.usedCurrencyCollection, function(item) {
                    return _c("el-option", {
                      key: item,
                      attrs: { label: item, value: item }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_EndDate") } },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "120px" },
                  attrs: { format: "yyyy-MM-dd", no: "7" },
                  model: {
                    value: _vm.form.overdueDate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "overdueDate", $$v)
                    },
                    expression: "form.overdueDate"
                  }
                })
              ],
              1
            ),
            _c("br"),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_DaysOverdue") } },
              [
                _c("el-input-number", {
                  staticStyle: { width: "50px" },
                  attrs: { controls: false, min: 0, precision: 0, no: "8" },
                  model: {
                    value: _vm.form.startDay,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "startDay", $$v)
                    },
                    expression: "form.startDay"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "-" } },
              [
                _c("el-input-number", {
                  staticStyle: { width: "50px" },
                  attrs: { controls: false, min: 0, precision: 0, no: "9" },
                  model: {
                    value: _vm.form.endDay,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "endDay", $$v)
                    },
                    expression: "form.endDay"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_Balance") } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "60px" },
                    attrs: { no: "10" },
                    model: {
                      value: _vm.form.operator,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "operator", $$v)
                      },
                      expression: "form.operator"
                    }
                  },
                  _vm._l(_vm.operatorArr, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.name, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c("el-input", {
                  staticStyle: { width: "80px" },
                  attrs: { no: "11" },
                  model: {
                    value: _vm.form.balance,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "balance", $$v)
                    },
                    expression: "form.balance"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c("el-checkbox", {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ShowOpeningBalance"),
                    no: "12"
                  },
                  model: {
                    value: _vm.form.showBalance,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "showBalance", $$v)
                    },
                    expression: "form.showBalance"
                  }
                }),
                _c("el-checkbox", {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ShowAdjustRateEntry"),
                    no: "13"
                  },
                  model: {
                    value: _vm.form.showAdjustRateEntry,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "showAdjustRateEntry", $$v)
                    },
                    expression: "form.showAdjustRateEntry"
                  }
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "el-margin",
                    staticStyle: { "margin-left": "20px" },
                    attrs: { type: "primary", no: "14" },
                    on: { click: _vm.doSearch }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "section", staticStyle: { flex: "1", padding: "0px" } },
      [
        _c("cargo-ag-grid", {
          staticStyle: { height: "800px" },
          attrs: {
            "show-side-bar": false,
            "column-defs": _vm.columnDefs,
            "grid-options": _vm.gridOptions,
            "grid-params": _vm.girdParams,
            "row-data": _vm.rowData,
            "auto-fit-content": false,
            no: "15"
          },
          on: {
            "update:gridParams": function($event) {
              _vm.girdParams = $event
            },
            "update:grid-params": function($event) {
              _vm.girdParams = $event
            }
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "pagination-wrapper" },
      [
        _c("debit-credit-total-group", {
          staticStyle: { float: "right", "margin-right": "10px" },
          attrs: {
            "row-data": _vm.rowData,
            visible: _vm.totalGroupVisible,
            no: "16"
          },
          on: {
            clickCallBack: function($event) {
              _vm.totalGroupVisible = !_vm.totalGroupVisible
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }